module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"feature_importance_for_boruta":"Feature importance for Boruta iterations","importance_hits":"Importance hits"},"fr":{"feature_importance_for_boruta":"Importance des features pour les itérations de Boruta","importance_hits":"Importance relative des features"}}')
  delete Component.options._Ctor
}
